<div class="main px-3 py-3">
  <div class="bg-grey">
  </div>
  <div class="page-header">
    <div class="title-container">マスタ権限設定</div>
  </div>
  <mat-tab-group class="mat-tab-fill-height" animationDuration="0ms">
    <mat-tab label="参照" class="label">
      <!-- 参照 -->
      <div class="looker-field">
        <div id="I-set-maintenance-controls" class="looker-embed"></div>
        <div class="download-button mt-3">
          <app-download-button style="margin-right: 3rem;"></app-download-button>
          <button mat-raised-button style="margin-right: 1rem;">アップロード申請</button>
          <button mat-raised-button>申請状況確認</button>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="設定履歴" class="label">
      <!-- 設定履歴 -->
      <div class="history-field">
        <div id="I-set-maintenance-controls-history" class="looker-embed"></div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

